import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { get, del } from "@utils/axios_api";
import { downloadExcel } from "@utils/downloadExcel";
/**
 * 목록조회 + 삭제 + 회원 목록 엑셀 다운 로직을 담당하는 훅
 */

const fetchMemberList = async (params) => {
    const response = await get("/admin/mem/memberList", { params });
    return response;
};
export function useMember(queryParam) {
  const [selectedItems, setSelectedItems] = useState([]);


  const { data, refetch } = useQuery({
    queryKey: ["selectAdminMemberList", queryParam],
    queryFn: () => fetchMemberList(queryParam),
    keepPreviousData: true,
  });

  const handleSelectAll = (checked) => {
    if (!data || !data.resultList) return;
    if (checked) {
      const allIds = data.resultList.map((item) => item.memberId);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (id) => {
    
    if (selectedItems.includes(id)) {
      setSelectedItems(selectedItems.filter((x) => x !== id));
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  };

  const memberDelete = async () => {
    if (!selectedItems.length) {
      alert("삭제할 항목을 선택해주세요.");
      return;
    }

    const isConfirmed = window.confirm("정말 삭제하시겠습니까?");
    if (!isConfirmed) return;
    
    try {
      const response = await del("/admin/mem/memberDelete", {
        data: {
          idlist: selectedItems,
        },
      });
      alert(response?.message);
      refetch(); 
      setSelectedItems([]); 
    } catch (err) {
      console.error(err);
      alert("삭제 실패");
    }
  };

  const handleExcelDownload = (e) => {
    e.preventDefault();
    downloadExcel({
      url: "/admin/mem/memberListExcelDown",
      params: queryParam,
      filePrefix: "회원 목록",
    });

  }

  const isAllChecked = !!(data?.resultList?.length && selectedItems.length === data?.resultList?.length);

  return { data, refetch, selectedItems, isAllChecked,  handleSelectAll, handleSelectItem, handleExcelDownload, memberDelete };
}
